import moment from 'moment'
import { isNil } from 'lodash'

export const extractOnlyNumbers = value => {
  return value === null ? '' : value.trim().replace(/[^0-9]/g, '')
}

export const formatDate = (value, patternFrom = 'DD/MM/YYYY', patternTo = 'YYYY-MM-DD') => {
  if (isNil(value)) {
    return ''
  }

  let dateFormatted = moment(value, patternFrom)
    .utc()
    .format(patternTo)

  if (!moment(dateFormatted, patternTo).isValid()) {
    dateFormatted = ''
  }

  return dateFormatted
}

export const capitalizeText = str => str.charAt(0).toUpperCase() + str.slice(1)

const formatter = {
  formatDate,
  extractOnlyNumbers
}

export default formatter
